import * as React from "react";

import { IHookProps } from "./props";

import { FEED_LOAD_COUNT } from "../constants";

export interface IHookHandlers extends ReturnType<typeof useHandlers> {}

export default function useHandlers(props: IHookProps) {
  const {
    dispatchSelectTrendingSection,
    dispatchGetDiscoverFeed,
    cancelToken,
    feed,
  } = props;
  const handleClickSection = React.useCallback(
    (section: Vingle.Discover.ITrendingSection) => {
      dispatchSelectTrendingSection({
        sectionId: section.id,
      });
    },
    [],
  );

  const handleLoadFeedData = React.useCallback(() => {
    dispatchGetDiscoverFeed({
      cancelToken: cancelToken.current.token,
      count: FEED_LOAD_COUNT,
      after: feed.paging.after,
    });
  }, [feed.paging.after]);

  return {
    handleLoadFeedData,
    handleClickSection,
  };
}
